// extracted by mini-css-extract-plugin
module.exports = {"modal_block":"DeleteAbsenceModal_modal_block__13ncE","footer":"DeleteAbsenceModal_footer__1xxne"};